module.exports = __webpack_public_path__ + "assets/4a2f6d1316cc560ede07d3334d3b486a.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-cyrillic-300-normal.woff2
// module id = 2618
// module chunks = 121